import { useCallback, useState } from 'react';
import { ButtonSet } from '@trinity/chat-components/components/Modal/ButtonSet.js';
import { Header } from '@trinity/chat-components/components/Modal/Header.js';
import { Modal, type ModalProps } from '@trinity/chat-components/components/Modal/Modal.js';
import { ButtonActivityIndicator, ButtonOutlined } from '@trinity/chat-components/components/presentation/index.js';
import { useTranscriptEnhancementStateMutation } from '@/containers/Transcript/hooks';
import type { TranscriptPublishType } from '@/enums';
import { TranscriptionRevisionStatus } from '@/enums';
import { useToggle } from '@trinity/chat-components/hooks/useToggle';
//import { QualPublishingCompliance } from '../Workspace.FilesTable/Publishing.Compliance';
import { PublishSettingsSelect } from './Publishing.Select';
import styles from './style/Publishing.module.css';

type Props = {
  onSuccess?: () => void;
} & Pick<ModalProps, 'onClose' | 'open'>
  & ITranscriptId;

export const PublishingTranscriptModal = ({ onSuccess, transcriptId, ...props }: Props) => {
  /*
  const [publishType, setPublishType] = useState(TranscriptPublishType.RecordingOnly);
  const mutation = useTranscriptEnhancementStateMutation({ transcriptId });
  const [displayCompliance, toggleDisplayCompliance] = useToggle(false);

  const handleSubmit = useCallback(() => {
    mutation.mutateAsync({
      publishType,
      statusId: TranscriptionRevisionStatus.Completed,
    })
      .then(() => onSuccess?.());
  }, [
    mutation,
    onSuccess,
    publishType,
  ]);

  return (
    <Modal
      onClose={props.onClose}
      open={props.open}>
      {!displayCompliance &&
        <PublishingTranscriptSetting
          onCancel={props.onClose}
          onChange={setPublishType}
          onSubmit={toggleDisplayCompliance}
          value={publishType} />}
      {displayCompliance &&
        <QualPublishingCompliance
          onCancel={toggleDisplayCompliance}
          onSubmit={handleSubmit}
          submitting={mutation.isPending} />}
    </Modal>
  );
  */
  return null;
};

PublishingTranscriptModal.displayName = 'Publishing.Transcript.Modal';

type PublishingTranscriptSettingProps = {
  onChange: (value: TranscriptPublishType) => void;
  onCancel: () => void;
  onSubmit: () => void;
  value: TranscriptPublishType;
};

const PublishingTranscriptSetting = (props: PublishingTranscriptSettingProps) => {
  return (
    <div className={styles.root}>
      <Header>
        Publish Transcript?
      </Header>
      <div className={styles.wrap}>
        <div className={styles.main}>
          <div className={styles.label}>Publish Setting</div>
          <PublishSettingsSelect
            onChange={e => props.onChange(e.target.value)}
            value={props.value} />
        </div>
        <ButtonSet className={styles.footer}>
          <ButtonOutlined
            className={styles.btn}
            onClick={props.onCancel}>
            Cancel
          </ButtonOutlined>
          <ButtonActivityIndicator
            className={styles.btn}
            color="primary"
            onClick={props.onSubmit}>
            Next
          </ButtonActivityIndicator>
        </ButtonSet>
      </div>
    </div>
  );
};

PublishingTranscriptSetting.displayName = 'Publishing.Transcript.Setting';